<ul class="notification-queue">
    <li *ngFor="let notification of notificationQueue; trackBy: trackByNotificationId" class="notification-queue__item" @stackedListItem>
        <ng-container [ngSwitch]="notification.eventName">
            <ng-container *ngSwitchCase="eventList.serviceRequestCreatedEvent">
                <app-service-request-notification
                    [notification]="$any(notification.data)"
                    (notificationClose)="onCloseNotification($event)"
                >
                </app-service-request-notification>
            </ng-container>

            <ng-container *ngSwitchCase="eventList.internalTripNotificationEvent">
                <app-internal-trip-notification
                    [notification]="$any(notification.data)"
                    (notificationClose)="onCloseNotification($event)"
                ></app-internal-trip-notification>
            </ng-container>

            <ng-container *ngSwitchCase="eventList.serviceRequestFlagEvent">
                <app-service-request-flag-notification
                    [notification]="$any(notification.data)"
                    (notificationClose)="onCloseNotification($event)"
                ></app-service-request-flag-notification>
            </ng-container>
        </ng-container>
    </li>
</ul>
